import React from "react";
import Select from "react-select";

/// <summary>
/// Author : -
/// </summary>
const StyledSelect = (props) => {
	const { options, placeholder = "", value, onChange, ...otherProps } = props;
	const _SELECT_STYLES = {
		dropdownIndicator: (styles) => ({
			...styles,
			color: "#FFFFFF",
			padding: "0 10px",
		}),
		menu: (styles, state) => ({
			...styles,
            background: '#0d1426',
		}),
		control: (styles, state) => ({
			...styles,
            background: 'rgba(45, 48, 53, 0.5)',
			borderRadius: "0.5rem",
            border: "none",
			height: "40px",
			fontSize: "1rem",
            fontWeight: "300",
		}),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				...styles,
				background: "rgba(45, 48, 53, 0.5)",
				fontSize: "1rem",
				fontWeight: "300",
				borderRadius: "0.5rem",
                
			};
		},
		singleValue: (styles) => ({
			...styles,
			fontSize: "1rem",
			color: "#FFFFFF",
			fontWeight: "300",
            padding: "0 10px",
		}),
		placeholder: (styles) => ({
			...styles,
			fontSize: "1rem",
			fontWeight: "300",
		}),
	};

	return (
		<Select
			options={options}
			isSearchable={false}
			styles={_SELECT_STYLES}
			placeholder={
				options.filter((option) => option.value == value)[0] !== undefined
					? options.filter((option) => option.value == value)[0].label
					: placeholder
			}
			value={options.filter((option) => option.value == value)}
			onChange={(e) => {
				onChange(e);
			}}
			components={{
				IndicatorSeparator: () => null,
			}}
			{...otherProps}
		/>
	);
};

export default StyledSelect;
